export default __webpack_public_path__ + "static/media/bike_image8.e0382dcf.jfif";